import Vue from 'vue'
import VueRouter from 'vue-router'

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err);
};
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: (reslove) => require(['@/views/NavBottom.vue'], reslove),
    children: [
      {
        path: '/',
        redirect: '/terminal',
      },
      {
        /**
         * 首页
         */
        path: '/index',
        name: 'Index',
        component: (reslove) => require(['@/views/Index.vue'], reslove),
      },
      {
        /**
         * 终端
         */
        path: '/terminal',
        name: 'Terminal',
        component: (reslove) => require(['@/views/Terminal.vue'], reslove),
      }, {
        /**
         * 节目
         */
        path: '/programs',
        name: 'Programs',
        component: (reslove) => require(['@/views/Programs.vue'], reslove),
      }, {
        /**
         * 我的
         */
        path: '/my',
        name: 'My',
        component: (reslove) => require(['@/views/My.vue'], reslove),
      }, {
        /**
         *遥控
         */
        path: '/telecontrol',
        name: 'telecontrol',
        meta: {
          title: '遥控'
        },
        component: (reslove) => require(['@/components/telecontrol.vue'], reslove),
      }, {
        /**
         * 任务详情
         */
        path: '/taskdetail',
        name: 'taskdetail',
        meta: {
          title: '任务详情'
        },
        component: (reslove) => require(['@/components/taskdetail.vue'], reslove),
      }, {
        /**
         * 添加任务
         */
        path: '/addTask',
        name: 'addTask',
        meta: {
          title: '添加任务'
        },
        component: (reslove) => require(['@/components/addTask.vue'], reslove),
      }, {
        /**
         * 节目列表
         */
        path: '/programItem',
        name: 'programItem',
        meta: {
          title: '节目列表'
        },
        component: (resolve) => require(['@/views/programItem.vue'], resolve),
      }, {
        /**
         * 终端信息
         */
        path: '/tinformation',
        name: 'Tinformation',
        meta: {
          title: '终端信息'
        },
        component: (resolve) => require(['@/views/Tinformation.vue'], resolve),
      }, {
        /**
         * 增加分辨率
         */
        path: '/addresolution',
        name: 'addresolution',
        meta: {
          title: '增加分辨率'
        },
        component: (resolve) => require(['@/views/addresolution.vue'], resolve),
      }, {
        /**
         * 增加节目
         */
        path: '/newprogram',
        name: 'newprogram',
        meta: {
          title: '增加节目'
        },
        component: (resolve) => require(['@/views/newprogram.vue'], resolve),
      },
      {
        /**
         * 素材管理
         */
        path: '/material',
        name: 'material',
        meta: {
          title: '素材管理'
        },
        component: (resolve) => require(['@/views/material.vue'], resolve),
      },
    ],
  },
  {
    /**
     * 创建节目
     */
    path: '/createProrram',
    name: 'createProrram',
    meta: {
      title: '创建节目'
    },
    component: (resolve) => require(['@/views/createProrram.vue'], resolve),
  },
  {
    /**
     * 创建节目
     */
    path: '/h5Prorram',
    name: 'h5Prorram',
    meta: {
      title: 'H5节目'
    },
    component: (resolve) => require(['@/views/h5Prorram.vue'], resolve),
    children: [
      {// 重定向，默认显示重定向的路由
        path: "/h5Prorram",
        redirect: "/h5Prorram/production"
      },
      {
        path: "/h5Prorram/template",
        name: "template",
        component: (resolve) => require(["@/views/template.vue"], resolve)
      },
      {
        path: "/h5Prorram/production",
        name: "production",
        component: (resolve) => require(["@/views/production.vue"], resolve)
      },
    ]
  },
  {
    /**
     * 登录
     */
    path: '/h5Preview/:id',
    name: 'h5Preview',
    meta: {
      title: '登录'
    },
    component: (resolve) => require(['@/views/h5Preview.vue'], resolve),
  },
  {
    /**
     * 登录
     */
    path: '/login',
    name: 'Login',
    meta: {
      title: '登录'
    },
    component: (resolve) => require(['@/views/Login.vue'], resolve),
  },
  {
    /**
     * 注册
     */
    path: '/Register',
    name: 'Register',
    meta: {
      title: '登录'
    },
    component: (resolve) => require(['@/views/Register.vue'], resolve),
  },
  {
    path: '/editPass',
    name: 'editPass',
    meta: {
      title: '修改密码'
    },
    component: (resolve) => require(['@/views/editPass.vue'], resolve),
  },
  {
    /**
     * 预览
     */
    path: '/preview',
    name: 'preview',
    meta: {
      title: '预览'
    },
    component: (resolve) => require(['@/views/preview.vue'], resolve),
  },
  {
    /**
     * 预览
     */
    path: '/h5editer/:id',
    name: 'h5editer',
    meta: {
      title: '预览'
    },
    component: (resolve) => require(['@/views/h5editer.vue'], resolve),
  },

]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
})

export default router
